import { ActivatedRoute } from "@angular/router";
import { JobsStore } from "./../jobs.store";
import { HotToastService } from "@ngneat/hot-toast";
import { JobsService } from "./../jobs.service";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { Job, TaskGroup, Task } from "./../job.model";
import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  SimpleChanges,
  SimpleChange,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import moment from "moment";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { Router } from "@angular/router";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { MomentModule } from "ngx-moment";

import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgClass, NgStyle } from "@angular/common";
import { IconCounterComponent } from "src/app/design-system/components/icon-counter/icon-counter.component";
import { StatusBadgeComponent } from "src/app/design-system/components/status-badge/status-badge.component";
import { PinComponent } from "src/app/design-system/components/pin/pin.component";
import { PinnedItem, PinnedModels } from "../../pinned-panel/pinned-models";
import { JobsGroupsDueComponent } from "../jobs-groups-due/jobs-groups-due.component";
import { ButtonModule } from "primeng/button";
import { TooltipModule as pTooltipModule } from 'primeng/tooltip';

@Component({
  selector: "app-jobs-and-tasks-card",
  templateUrl: "./jobs-and-tasks-card.component.html",
  styleUrls: ["./jobs-and-tasks-card.component.scss"],
  imports: [
    NgClass,
    NgStyle,
    TooltipModule,
    MomentModule,
    IconCounterComponent,
    StatusBadgeComponent,
    PinComponent,
    JobsGroupsDueComponent,
    pTooltipModule,
    ButtonModule
  ],
})
export class JobsAndTasksCardComponent implements OnInit, AfterViewInit {
  bsModalRef: BsModalRef;
  mm = moment;

  duplicateSelected: string;
  duplicateSelectedObj = null;

  @Input() set job(value: Job) {
    this._job = value;
    this._job["isOverdue"] = this.isJobOverdue(this._job.due_date);
  }

  @Input() templateManager: boolean = false;

  _job: Job;

  hovering = false;
  pinModel = PinnedModels.Job;

  constructor(
    public toastr: HotToastService,
    public dashboardStore: DashboardStore,
    public jobsService: JobsService,
    public jobsStore: JobsStore,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.jobsService.jobContentChanged.subscribe((job: Job) => {
      if (job.uuid == this._job.uuid) {
        let selected = this._job["selected"];
        this._job = job;
        this._job["selected"] = selected;
        this._job["isOverdue"] = this.isJobOverdue(this._job.due_date);

        this.cdr.detectChanges();
      }
    });

    this.jobsService.setSelectedJob.subscribe((uuid) => {
      if (this._job.uuid == uuid) {
        this._job["selected"] = true;
      } else {
        this._job["selected"] = false;
      }
    });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  getUndoneTasksCount() {
    if (this._job["undone_tasks_count"] != null) {
      return this._job["undone_tasks_count"];
    }

    let count = 0;

    this._job.task_groups.forEach((tg: TaskGroup) => {
      tg.tasks.forEach((t: Task) => {
        if (!t.completed && t.related_tracked_item == null && t.name != "")
          count++;
      });
    });

    return count;
  }

  getTotalTasksCount() {
    if (this._job["tasks_count"] != null) {
      return this._job["tasks_count"];
    }

    let count = 0;

    this._job.task_groups.forEach((tg: TaskGroup) => {
      tg.tasks.forEach((t: Task) => {
        if (t && t.name != "" && t.related_tracked_item == null) count++;
      });
    });

    return count;
  }

  getUndoneClientTasksCount() {
    if (this._job["undone_client_tasks_count"] != null) {
      return this._job["undone_client_tasks_count"];
    }

    let count = 0;

    this._job.task_groups.forEach((tg: TaskGroup) => {
      tg.tasks.forEach((t: Task) => {
        if (!t.completed && t.related_tracked_item != null) count++;
      });
    });

    return count;
  }

  getTotalClientTasksCount() {
    if (this._job["client_tasks_count"] != null) {
      return this._job["client_tasks_count"];
    }

    let count = 0;

    this._job.task_groups.forEach((tg: TaskGroup) => {
      tg.tasks.forEach((t: Task) => {
        if (
          t &&
          t.name != "" &&
          t.related_tracked_item &&
          t.related_tracked_item["uuid"] != null
        )
          count++;
      });
    });

    return count;
  }

  isJobOverdue(due_date) {
    return moment(due_date, "MM-DD-YYYY").isBefore(new Date());
  }
}
